import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { X, Megaphone } from "lucide-react";

export default function AnnouncementBar() {
  const announcements = [
    "India's Best Male to Male Spa & Wellness Group",
    "Premium Gay Spa in New Delhi",
    "Experience Luxury Male Grooming & Rejuvenation",
    "100% Safe, Discreet & Highly Professional Spa for Men",
    "Book Your In-Spa or Doorstep Session Online"
  ];
  
  const displayText = [...announcements, ...announcements].join(" \u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00b7\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0 ");
  
  return (
    <div data-testid="announcement-bar" className="fixed top-0 inset-x-0 z-[60] bg-gradient-to-r from-[#BF953F] via-[#FCF6BA] to-[#B38728] text-black h-8 flex items-center overflow-hidden">
      <div className="w-full overflow-hidden whitespace-nowrap relative flex">
        <div className="animate-marquee inline-block text-xs font-semibold uppercase tracking-wider py-1 select-none">
          {displayText}
        </div>
      </div>
      <style>{`
        .animate-marquee {
          display: inline-block;
          animation: marquee-scroll 35s linear infinite;
        }
        @keyframes marquee-scroll {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
